import {
  Button,
  Dialog,
  FormInputDate,
  P,
} from '@fashionnovateam/nova-ui-toolkit';
import { useState } from 'react';
import { useMarkPrevSampleAsReceived } from '../hooks/queries';
import { useCounterContext } from '../hooks/useCounter';
import toast from '../../Toast/Toast';

function PrevSampleReceivedDialog({
  handleClose,
  open,
}: {
  handleClose: () => void;
  open: boolean;
}) {
  const { selectedCounter, userId } = useCounterContext();
  const [selectedDate, setSelectedDate] = useState<string>('');
  const markPrevSampleAsReceived = useMarkPrevSampleAsReceived();

  const handleMarkAsReceived = async () => {
    if (!userId || !selectedCounter) {
      return;
    }
    try {
      await markPrevSampleAsReceived.mutateAsync({
        userId,
        counterId: selectedCounter.counter_id,
        data: {
          prev_sample_received_at: selectedDate,
        },
      });
      toast(
        { title: 'Prev Sample successfully marked as received' },
        { type: 'success' },
      );
      setSelectedDate('');
      handleClose();
    } catch (error) {
      console.error('Failed to mark prev sample as received:', error);
      toast(
        { title: 'Failed to mark prev sample as received' },
        { type: 'error' },
      );
    }
  };

  const now = new Date();
  const notBefore = selectedCounter?.prev_sample_shipped_at?.slice(0, 10);
  const notAfter = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

  return (
    <Dialog isOpen={open} onClose={handleClose}>
      <Dialog.Header />
      <Dialog.Content className="w-full">
        <div className="flex flex-col gap-6 w-full">
          <div className="flex-col mb-6">
            <Dialog.Title>Confirm previous sample receipt</Dialog.Title>
            <P size="xsm" color="disabled">
              Please review and confirm the receipt date is accurate.
            </P>
          </div>
          <FormInputDate
            className="w-full"
            containerClassName="w-full"
            label="Date Prev Sample received"
            required
            value={selectedDate}
            onChangeValue={setSelectedDate}
            notBefore={notBefore}
            notAfter={notAfter}
          />
        </div>
      </Dialog.Content>
      <Dialog.Footer>
        <div className="flex gap-2 justify-end">
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleMarkAsReceived}
            loading={markPrevSampleAsReceived.isLoading}
            disabled={!selectedDate}
          >
            Mark as Received
          </Button>
        </div>
      </Dialog.Footer>
    </Dialog>
  );
}

export default PrevSampleReceivedDialog;
